import clsx from 'clsx'

interface RankTileProps {
  rank: number
  prevRank: number | null
  label: string
}

/**
 * Prominent, centered ranking "tile" for the team page hero. Shows a large
 * "#N" with the source label and a week-over-week movement chip.
 */
export function RankTile({ rank, prevRank, label }: RankTileProps) {
  const delta = prevRank ? prevRank - rank : 0
  const direction = delta > 0 ? 'up' : delta < 0 ? 'down' : 'same'

  return (
    <div className="inline-flex flex-col items-center gap-2 rounded-2xl border border-accent/30 bg-gradient-to-b from-accent/15 to-accent/5 px-8 py-4 shadow-lg shadow-accent/10">
      <div className="flex items-start leading-none">
        <span className="mt-1 text-2xl font-bold text-accent/50">#</span>
        <span
          className="text-5xl font-extrabold text-accent"
          style={{ fontVariantNumeric: 'tabular-nums' }}
        >
          {rank}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-[11px] font-medium uppercase tracking-widest text-slate-400">
          {label}
        </span>
        {prevRank != null && delta !== 0 && (
          <span className={clsx(
            'flex items-center gap-0.5 text-xs font-semibold',
            direction === 'up' ? 'text-trend-up' : 'text-trend-down',
          )}>
            <svg
              className={clsx('h-3 w-3', direction === 'down' && 'rotate-180')}
              viewBox="0 0 12 12"
              fill="currentColor"
            >
              <path d="M6 2l4 5H2z" />
            </svg>
            <span style={{ fontVariantNumeric: 'tabular-nums' }}>{Math.abs(delta)}</span>
          </span>
        )}
      </div>
    </div>
  )
}
